import { initFilters } from "../shared/filter";
import { initForms } from "../shared/form";
import { initLightBoxes } from "./components/lightbox";
import { initLoadmore } from "./components/loadmore";
import { initMediaWall } from "./components/mediawall";
import { initNav } from "../shared/navigation";
import { initReadmore } from "./components/readmore";
import { initScroll } from "../shared/scroll";
import { initSearch } from "./components/search";
import { initShows } from './components/shows';


(function () {
  initFilters()

  initForms()

  initLightBoxes()

  initLoadmore()

  initMediaWall()
  
  initNav()

  initReadmore()

  initScroll()

  initSearch()

  initShows()
})()